import { ComponentTypes } from '@wix/editor-const';

export const SUPPORTED_PLUGIN_COMPONENT_TYPES = [
  ComponentTypes.RefComponent,
  ComponentTypes.TpaWidget,
  ComponentTypes.CustomElement,
];

export const SUPPORTED_HOST_PLUGIN_COMPONENT_TYPES = [
  ComponentTypes.TpaWidget,
  ComponentTypes.TpaSection,
  ComponentTypes.TpaMultiSection,
];

export enum ComponentPreviewState {
  HIGHLIGHTED = 'highlighted',
}
